import { createSlice } from "@reduxjs/toolkit";
import { deleteContactAPI } from "../../api/contact";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const deleteContactSlice = createSlice({
  name: "deleteContact",
  initialState: data,
  reducers: {
   deleteContactSlice(state) {
      state.isLoading = true;
    },
   deleteContactSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteContactSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteContactSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const deleteContactHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(deleteContactAction.deleteContactSlice());
    const response: any = await deleteContactAPI(id);
    
    dispatch(deleteContactAction.deleteContactSliceSuccess(response));
  } catch (e: any) {
    dispatch(deleteContactAction.deleteContactSliceFailure(e?.response?.data));
  }
};
export default deleteContactSlice.reducer;
export const deleteContactAction = deleteContactSlice.actions;
